import { Entity } from '../../../domain/entity'
import { Utils } from '../../../utils/common'
import { AdTargets } from '../targeting/target'

export type AdSize = number[]
export type AdSizes = AdSize | AdSize[]
export enum AdType {
    HTML = 'html',
    VIDEO = 'video'
}

export interface IAd {
    el: Element
    id: string
    isOutOfPage: boolean
    size: AdSizes
    targets?: AdTargets
    type: AdType

    display(size: AdSize): void
    fallBack(content: string): void
}

export class Ad extends Entity implements IAd {
    public static defaultSizeX = 300
    public static defaultSizeY = 250
    public static defaultSize: AdSize = [Ad.defaultSizeX, Ad.defaultSizeY]
    public static defaultType = AdType.HTML

    public id: string
    public size: AdSizes
    public type: AdType

    /**
     * Initializes the ad.
     *
     * @param {Element} el
     * @param {AdSizes} size
     * @param {AdTargets} targets
     * @param {AdType} type
     */
    public constructor(
        public el: Element,
        size?: AdSizes,
        public targets?: AdTargets,
        public isOutOfPage = false,
        type?: AdType) {
        super()

        // require id
        if (!el.hasAttribute('id')) {
            el.setAttribute('id', `ad-${Utils.shortId()}`)
        }
        this.id = el.getAttribute('id')

        // out-of-page ads have no size
        if (!isOutOfPage) {
            this.size = size || Ad.defaultSize
        }

        this.type = type || Ad.defaultType
    }

    /**
     * Called upon ad load
     *
     * @param {AdSize} size actual size of ad (will be one of requested)
     */
    public display(size?: AdSize): void {
        // TODO: display fallback if no ad available

        // exists for sake of extending, this to use the arg:
        size // tslint:disable-line: no-unused-expression
    }

    /**
     * Displays fallback ad.
     */
    public fallBack(s: string): void {
        this.el.innerHTML = s
    }
}
